import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=9883937e&scoped=true&"
import script from "./payFail.vue?vue&type=script&lang=ts&"
export * from "./payFail.vue?vue&type=script&lang=ts&"
import style0 from "./payFail.vue?vue&type=style&index=0&id=9883937e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9883937e",
  null
  
)

export default component.exports